import { Grid } from "@mui/material";
import styled from "@emotion/styled";
import { FIXED_HEADER_OFFSET } from "../../components/layouts/headerLayout";

/** Reserve the fixed app header above both live Search result presentations. */
const CompanySearchShell = styled(Grid)(() => ({
  padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px`,
  "@media (max-width: 900px)": { padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px` },
}));

export default CompanySearchShell;
